import { defineEffect } from '../../../core/effect';

/**
 * **攻撃が無効になった**（Issue #552）。攻撃宣言が盤に置いた矢印と小さいパネルを消す（`clears`）。絵は持たない。
 */
export default defineEffect({
  situation: 'attack_disabled',
  role: 'effect',
  label: '攻撃の無効（矢印を消す）',
  color: '#8a8aa0',
  duration: () => 1,
  clears: () => [{ mark: 'attackArrow' }, { mark: 'battlePanel' }],
}, 'attack_disabled_effect.js');
